import { withFormik } from 'formik';
import { RouteComponentProps, withRouter } from 'react-router';
import { connect, MapStateToProps } from 'react-redux';
import * as Yup from 'yup';
import { History } from 'history';
import { AppThunk } from '../../../app/store';
import { ActionCreatorWithPayload } from '@reduxjs/toolkit';
import { EditTaskDetailsForm } from './EditTaskDetailsForm';
import {
  setName,
  setTaskTypeId,
  setTaskStep,
  addTaskImageToS3,
} from '../../../slices/taskSlice';
import {
  NAME_REQUIRED,
  TASK_TYPE_REQUIRED,
} from '../../../constants/formMessages';
import { RootState } from '../../../app/rootReducer';

interface IDispatchProps {
  setName: ActionCreatorWithPayload<string, string>;
  setTaskTypeId: ActionCreatorWithPayload<string, string>;
  setTaskStep: ActionCreatorWithPayload<number, string>;
  addTaskImageToS3: () => AppThunk;
}

export interface EnhancedEditTaskDetailsFormValues {
  name: string;
  taskTypeId: string;
  instructions: string[];
}
export interface EnhancedEditTaskDetailsFormProps extends RouteComponentProps {
  name?: string;
  taskTypeId?: string;
  instructions?: string[];
  setName: ActionCreatorWithPayload<string, string>;
  setTaskTypeId: ActionCreatorWithPayload<string, string>;
  setTaskStep: ActionCreatorWithPayload<number, string>;
  addTaskImageToS3: () => void;
}

const EnhancedEditTaskDetailsForm = withFormik<
  EnhancedEditTaskDetailsFormProps,
  EnhancedEditTaskDetailsFormValues
>({
  mapPropsToValues: ({ name, taskTypeId, instructions }) => ({
    name: name ? name : '',
    taskTypeId: taskTypeId ? taskTypeId : '',
    instructions: instructions ? instructions : [],
  }),
  validationSchema: Yup.object().shape({
    name: Yup.string().required(NAME_REQUIRED),
    //setTaskTypeId: Yup.string().required(TASK_TYPE_REQUIRED),
  }),
  handleSubmit: (values, { setSubmitting, props, resetForm }) => {
    const { setName, setTaskTypeId, setTaskStep, addTaskImageToS3 } = props;
    const { name, taskTypeId } = values;
    setName(name);
    setTaskTypeId(taskTypeId);
    setTaskStep(1);
    //addTaskImageToS3();
    setSubmitting(false);
    resetForm();
  },
  enableReinitialize: true,
  displayName: 'BasicForm',
})(EditTaskDetailsForm);

const EnhancedEditTaskDetailsFormWithRouter = withRouter(
  EnhancedEditTaskDetailsForm
);

const mapStateToProps = (state: RootState, ownProps: any = {}) => ({
  name: state.task.name,
  taskTypeId: state.task.taskTypeId,
  instructions: state.task.instructions,
});

export default connect(mapStateToProps, {
  setName,
  setTaskTypeId,
  setTaskStep,
  addTaskImageToS3,
})(EnhancedEditTaskDetailsFormWithRouter);
